export default "__VITE_ASSET__Dvf05JIK__"